import { SharedSurveyType, SharedSurvey } from "../types";
import { getFormattedDate } from "@utils/helperFunctions";

const formatSharedSurveys = (data): SharedSurveyType => {
  const formattedSharedSurveys: SharedSurvey[] = data.data
    .filter((survey) => survey.attributes.emails !== "")
    .map((survey) => {
      return {
        id: Number(survey.id),
        attributes: {
          name: survey.attributes.name ? survey.attributes.name : "",
          status: survey.attributes.status ? survey.attributes.status : "",
          sentBy: survey.attributes.sender ? survey.attributes.sender : "",
          sentTo: survey.attributes.emails ? survey.attributes.emails : "",
          sentOn: survey.attributes["sent-at"]
            ? getFormattedDate(new Date(survey.attributes["sent-at"]))
            : "",
          projectId: survey.relationships.project?.data?.id,
          questionnaireId: survey.relationships.questionnaire.data.id,
        },
      };
    });
  return {
    data: formattedSharedSurveys,
    meta: { ...data?.meta, "record-count": formattedSharedSurveys.length },
    included: data.included,
  };
};

export default formatSharedSurveys;
